'use client';

import { useEffect } from "react";

export const Hamburger = () => {
  const toggleMenu = () => {
    const nav = document.querySelector('.navigation-list-wrapper');
    const hamburger = document.querySelector('.hamburger');
    const body = document.querySelector('body');

    nav.classList.toggle('is-active');
    hamburger.classList.toggle('is-active');
    body.classList.toggle('prevent-scroll');
  }

  // Hide Sticky JS Class option in hamburger to render navigation server side
  // because hamburger is already rendered on client side

  useEffect(() => {
    const body = document.querySelector('body');
    const navigation = document.querySelector('.navigation-element-container');
    const scrollPosition = window.scrollY;
    body.classList.remove('prevent-scroll');

    // onload set initial status based on scroll position
    if (scrollPosition === 0) {
      navigation.classList.remove('is-scrolled');
    } else {
      navigation.classList.add('is-scrolled');
    }

    // on scroll add/remove class based on scroll position
    document.addEventListener('scroll', () => {
      const scrollPositionScroll = window.scrollY;
      if (scrollPositionScroll === 0) {
        navigation.classList.remove('is-scrolled');
      } else {
        navigation.classList.add('is-scrolled');
      }
    });
  });

  return (
    <button className="hamburger" aria-haspopup="true" aria-expanded="false" aria-label="Navigationsmenü öffnen" onClick={toggleMenu}>
      <span></span>
    </button>
  )
};

export default Hamburger;